import { render, staticRenderFns } from "./accessi.vue?vue&type=template&id=b154dd98"
import script from "./accessi.vue?vue&type=script&lang=js"
export * from "./accessi.vue?vue&type=script&lang=js"
import style0 from "./accessi.vue?vue&type=style&index=0&id=b154dd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports